import { useAddFinancialDocumentToImporterMutation } from "@api/financialDocument.api";
import { FinancialDocumentListItem } from "@common/types/financialDocument";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { useContext } from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { ImporterContext } from "./importer.context";
import { getImporterDocumentEligibility } from "./importerDocumentEligibility";
import { useNotifyUnfinishedImport } from "./useNotifyUnfinishedImport";

interface Props {
    financialDocument: FinancialDocumentListItem;
}

export const ImporterPickExistingDocumentCta: React.FC<Props> = ({
    financialDocument,
}) => {
    const { importerQueue, reconciliedFinancialAccount } =
        useContext(ImporterContext);
    const { isAlreadyAdded, isDisabled, disabledTooltip } =
        getImporterDocumentEligibility({ financialDocument, importerQueue });
    const notifyUnfinishedImport = useNotifyUnfinishedImport("transactions");

    const addToImporter = useAddFinancialDocumentToImporterMutation({
        financialDocument,
        importerQueue: reconciliedFinancialAccount ? undefined : importerQueue,
        reconciliedFinancialAccountId: reconciliedFinancialAccount?.id,
        onSuccess: (updatedDocument) =>
            notifyUnfinishedImport([updatedDocument]),
    });

    return (
        <Tooltip content={disabledTooltip}>
            <ButtonWithLoader
                variant="primary"
                size="sm"
                loading={addToImporter.isPending}
                onClick={() => {
                    addToImporter.mutate();
                }}
                disabled={isDisabled}
            >
                {isAlreadyAdded ? "Added" : "Add"}
            </ButtonWithLoader>
        </Tooltip>
    );
};
